export function initMap() {
    const mapContainer = document.querySelector('.map svg');
    const listContainer = document.querySelector('.map-listing');
    const infoBoxes = document.querySelectorAll('.col-lg-3');
    const allCards = document.querySelectorAll('.map-tooltip-card');
    
    let floatingTooltip = document.getElementById('map-floating-tooltip') || createTooltip();

    function createTooltip() {
        const el = document.createElement('div');
        el.id = 'map-floating-tooltip';
        el.className = 'map-tooltip';
        document.body.appendChild(el);  
        return el; 
    }

    const controlVideos = (action) => {
        const method = action === 'play' ? 'play' : 'pause';
        allCards.forEach(card => {
            const iframe = card.querySelector('iframe');
            if (iframe && (action === 'pause' || card.style.display !== 'none')) {
                iframe.contentWindow.postMessage(JSON.stringify({ method }), "*");
            }
        });
    };

    // MODIFIED: Added keepTooltip parameter
    const resetAll = (keepTooltip = false) => {
        controlVideos('pause');
        allCards.forEach(card => card.style.display = 'none');
        infoBoxes.forEach(box => box.classList.remove('active', 'show-map', 'pos-left', 'pos-right'));
        
        document.querySelectorAll('.active, .hover-active').forEach(el => {
            if (!el.classList.contains('map-tooltip')) el.classList.remove('active', 'hover-active');
        });
        
        // Only hide if we aren't hovering
        if (!keepTooltip) {
            floatingTooltip.classList.remove('active');
        }
    };

    const showSidebarCard = (countryId, isHover = false) => {
        if (!countryId) return;
        
        // Pass the hover state to resetAll
        resetAll(isHover);

        const mapItem = document.getElementById(countryId);
        if (!mapItem || !mapItem.dataset.side) return;

        const side = mapItem.dataset.side;
        const infoBox = document.getElementById(`${side}-info-box`);
        const targetCard = infoBox?.querySelector(`.map-tooltip-card[data-country-id="${countryId}"]`);

        if (targetCard && infoBox) {
            targetCard.style.display = 'block';
            infoBox.classList.add('active', 'show-map', `pos-${side}`);
            mapItem.classList.add('active');
            document.querySelector(`.map-listing li#${CSS.escape(countryId)}`)?.classList.add('active');

            const iframe = targetCard.querySelector('iframe');
            if (iframe) iframe.contentWindow.postMessage(JSON.stringify({ method: 'play' }), "*");
        }
    };

    let tick = false;
    document.addEventListener('mousemove', (e) => {
        if (!floatingTooltip.classList.contains('active')) return;
        
        if (!tick) {
            requestAnimationFrame(() => {
                floatingTooltip.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0) translate(-50%, -140%)`;
                tick = false;
            });
            tick = true;
        }
    });

    const handleHover = (e, isEntering) => {
        const target = e.target.closest('g[id], li[id]');
        if (!target) return;

        const id = target.id;
        const linkedNav = document.querySelector(`.map-listing li#${CSS.escape(id)}`);
        const linkedSvg = document.getElementById(id);

        if (isEntering) {
            if (linkedNav?.classList.contains('active') === false) linkedNav.classList.add('hover-active');
            if (linkedSvg?.classList.contains('active') === false) linkedSvg.classList.add('hover-active');
            
            if (target.tagName === 'g' && target.hasAttribute('data-side')) {
                const displayName = linkedNav ? linkedNav.textContent.trim() : id.replace(/-/g, ' ');
                floatingTooltip.textContent = displayName;
                floatingTooltip.classList.add('active');
            }
        } else {
            linkedNav?.classList.remove('hover-active');
            linkedSvg?.classList.remove('hover-active');
            floatingTooltip.classList.remove('active');
        }
    };

    let lastHoveredId = null;

    [mapContainer, listContainer].forEach(parent => {
        if (!parent) return;

        parent.addEventListener('mouseover', (e) => {
            const target = e.target.closest('g[id], li[id]');
            
            // 1. Run tooltip logic
            handleHover(e, true);

            // 2. Run sidebar logic (Pass 'true' to signal this is a hover)
            if (target && target.id !== lastHoveredId) {
                lastHoveredId = target.id;
                showSidebarCard(target.id, true); 
            }
        });

        parent.addEventListener('mouseout', (e) => {
            handleHover(e, false);
            const target = e.target.closest('g[id], li[id]');
            if (target) lastHoveredId = null;
        });

        parent.addEventListener('click', (e) => {
            const target = e.target.closest('g[id], li[id]');
            if (!target) return;
            e.stopPropagation();  
            target.classList.contains('active') ? resetAll() : showSidebarCard(target.id, false);
        });
    });

    document.addEventListener('click', () => resetAll(false));
}